import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { BaseFieldComponent } from '../base-field.component';

@Component({
    standalone: false,
    selector: 'ziq-number-value-field',
    templateUrl: './number-value-field.component.html',
    styleUrls: ['./number-value-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NumberValueFieldComponent extends BaseFieldComponent {
    @HostBinding('class')
    readonly hostClass = 'ziq-number-value-field';

    get currentValue() {
        return this.modelValue?.currentState?.[this.property];
    }

    onCurrentValueChange(value: unknown) {
        if (this.modelValue?.currentState) {
            this.modelValue.currentState[this.property] = value;
        }
    }
}
